export const creatOrderSecond = [
  {
    path: `/CreatOrderSecond`,
    name: `CreatOrderSecond`,
    redirect: `/creatOrderSecond/second`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/creatOrderSecond/second',
        name: 'CreatOrderSecond/second',
        component: () => import('@/views/creatordersecond/CreatOrderSecond')
      }
    ]
  }
];
